import { useMemo } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { filterNav, NAV_ITEMS } from '../nav';
import { useAuthStore } from '../stores/authStore';
import Sidebar from './Sidebar';

export default function AppLayout() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  const items = useMemo(() => {
    if (!user) return [];
    // OWNER 传 null 表示「全部可见」——权限展开在后端完成，前端不再判断角色默认集
    const permissions = user.role === 'OWNER' ? null : user.permissions;
    return filterNav(NAV_ITEMS, { permissions });
  }, [user]);

  return (
    <div className="flex h-screen w-full">
      <Sidebar
        items={items}
        title={user?.tenant.name ?? 'CUITO'}
        onLogout={() => {
          logout();
          navigate('/login', { replace: true });
        }}
      />
      <main className="flex-1 overflow-y-auto bg-white p-8">
        <Outlet />
      </main>
    </div>
  );
}
